export const importToOptions = [
  { value: "order", name: "التبرعات" },
  { value: "project", name: "المشاريع" },
  { value: "cart", name: "السلات المتروكة" },
  { value: "giftProject", name: "الاهداءات" },
];

export const importDataUrlMapOptions = {
  project: {
    jode: "/api/AdminProject/import-projects-from-jode",
    khazama: "/api/AdminProject/import-projects-from-khazama",
  },
  giftProject: {
    jode: "/api/AdminGiftProject/import-gift-projects-from-jode",
    khazama: "/api/AdminGiftProject/import-gift-projects-from-khazma",
  },
  cart: {
    jode: "/api/AdminCart/import-abandoned-cart-items-from-jode",
    khazama: "/api/AdminCart/import-abandoned-cart-items-from-khazma",
  },
};

export const importFromOptions = [
  { value: "jode", name: "جود" },
  { value: "khazama", name: "خزامي" },
];
